import { createApi } from '@reduxjs/toolkit/query/react';

import { StatusDto } from '../common/dto/common.dto';
import { FilterTypes, FilterViewDto } from '../common/dto/filter.dto';
import customFetchBase from './base.service';

const API_URI = import.meta.env.VITE_CORE_SERVICE;
const TAG_TYPE = 'Filter';

export const filterApi = createApi({
  reducerPath: 'filterApi',
  baseQuery: customFetchBase(`${API_URI}/api/saved-filter`),
  tagTypes: [TAG_TYPE],
  endpoints: (builder) => ({
    getFilters: builder.mutation<FilterViewDto[], Partial<{ type: FilterTypes; templateId?: string }>>({
      query(data) {
        return {
          url: ``,
          method: 'PATCH',
          body: data,
        };
      },
      invalidatesTags: [TAG_TYPE],
    }),
    updateFilter: builder.mutation<FilterViewDto, Partial<FilterViewDto>>({
      query(data) {
        return {
          url: ``,
          method: 'PUT',
          body: data,
        };
      },
      invalidatesTags: [TAG_TYPE],
    }),
    addFilter: builder.mutation<FilterViewDto, Partial<FilterViewDto>>({
      query(body) {
        return {
          url: ``,
          method: 'POST',
          body,
        };
      },
      invalidatesTags: [TAG_TYPE],
    }),
    deleteFilter: builder.mutation<StatusDto, string>({
      query(id: string) {
        return {
          url: `${id}`,
          method: 'DELETE',
        };
      },
      invalidatesTags: [TAG_TYPE],
    }),
  }),
});

// auto-generated based on the defined endpoints
export const { useGetFiltersMutation, useAddFilterMutation, useUpdateFilterMutation, useDeleteFilterMutation } = filterApi;
